import {
  CmBox,
  CmErrorText,
  CmFormLabel,
  CmHelpterText,
  CmInput,
  CmRadio,
  CmRadioGroup,
  CmStack,
  CmText,
} from '@/components/uiParts';
import { FormError } from '@/validate';

import {
  CustomOrderTypeDisplayName,
  HandleChangeIsCustomOrderTypeDisplayName,
  HandleChangeOrderTypeDisplayName,
  OrderMethod,
} from '../OrderMethodDisplayNameSettingFormItem/type';

type Props = {
  method: OrderMethod;
  methodData: CustomOrderTypeDisplayName;
  handleChangeIsCustomOrderTypeDisplayName: HandleChangeIsCustomOrderTypeDisplayName;
  handleChangeOrderTypeDisplayName: HandleChangeOrderTypeDisplayName;
  textError: FormError;
  buttonTextError: FormError;
};

export const OrderMethodDisplayNameSettingFormSubItem: React.FC<Props> = ({
  method,
  methodData,
  handleChangeIsCustomOrderTypeDisplayName,
  handleChangeOrderTypeDisplayName,
  textError,
  buttonTextError,
}) => {
  const title =
    method === 'takeout'
      ? 'テイクアウト'
      : method === 'eat_in'
      ? '店内飲食'
      : 'デリバリー';
  const defaultSettingText =
    method === 'takeout'
      ? '（項目名：テイクアウト、ボタンテキスト：お持ち帰り店舗を選択する）'
      : method === 'eat_in'
      ? '（項目名：店内飲食、ボタンテキスト：ご利用店舗を選択する）'
      : '（項目名：デリバリー、ボタンテキスト：お届け先を設定する）';
  const isCustom = methodData.is_custom === '1';

  return (
    <CmRadioGroup
      value={methodData.is_custom}
      onChange={(e: string) =>
        handleChangeIsCustomOrderTypeDisplayName(method, e)
      }
    >
      <CmStack direction="row">
        <CmFormLabel fontWeight="bold" width="100px">
          {title}
        </CmFormLabel>
        <CmStack direction="column" flexGrow={1} flexShrink={1}>
          <CmRadio size="md" value={'0'}>
            <CmText>デフォルト設定 {defaultSettingText}</CmText>
          </CmRadio>

          <CmRadio size="md" value={'1'}>
            カスタム設定
          </CmRadio>
          {isCustom && (
            <>
              <CmStack direction="row" alignItems="center">
                <CmFormLabel flexBasis="120px" fontWeight="bold" flexShrink={0}>
                  項目名
                </CmFormLabel>
                <CmBox flexGrow={1}>
                  <CmInput
                    value={methodData.text ?? ''}
                    isInvalid={textError.isTouched && textError.isError}
                    onChange={(e) =>
                      handleChangeOrderTypeDisplayName(
                        method,
                        isCustom,
                        'text',
                        e.target.value
                      )
                    }
                  />
                  <CmErrorText>{textError.message}</CmErrorText>
                </CmBox>
                <CmHelpterText flexBasis="120px" mt="3px">
                  ＊10字以内
                </CmHelpterText>
              </CmStack>
              <CmStack direction="row" alignItems="center">
                <CmFormLabel flexBasis="120px" fontWeight="bold" flexShrink={0}>
                  ボタンテキスト
                </CmFormLabel>
                <CmBox flexGrow={1}>
                  <CmInput
                    value={methodData.button_text ?? ''}
                    isInvalid={
                      buttonTextError.isTouched && buttonTextError.isError
                    }
                    onChange={(e) =>
                      handleChangeOrderTypeDisplayName(
                        method,
                        isCustom,
                        'button_text',
                        e.target.value
                      )
                    }
                  />
                  <CmErrorText>{buttonTextError.message}</CmErrorText>
                </CmBox>
                <CmHelpterText flexBasis="120px" mt="3px">
                  ＊15字以内
                </CmHelpterText>
              </CmStack>
            </>
          )}
        </CmStack>
      </CmStack>
    </CmRadioGroup>
  );
};
